// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getAnalytics } from "firebase/analytics";
import { getMessaging } from "firebase/messaging/sw";
import { getToken, onMessage } from "firebase/messaging";
import { app, payload } from "modular-openscriptjs";
import { getAuth, GoogleAuthProvider, OAuthProvider } from "firebase/auth";
import { PushNotifications } from "@capacitor/push-notifications";
import { Capacitor } from "@capacitor/core";
import { LocalNotifications } from "@capacitor/local-notifications";

// Your web app's Firebase configuration
const firebaseConfig = {
    apiKey: "AIzaSyDI8a2D8XuU6s_PfY8DkpVKgj1P-SvVtB4",
    authDomain: "carata-29f2f.firebaseapp.com",
    projectId: "carata-29f2f",
    storageBucket: "carata-29f2f.firebasestorage.app",
    messagingSenderId: "584850289679",
    appId: "1:584850289679:web:5fa5bdc5bbbd2446eb9f7a",
    measurementId: "G-FCS7T549PK",
};

// Initialize Firebase
const firebaseApp = initializeApp(firebaseConfig);
const firebaseAnalytics = getAnalytics(firebaseApp);

export const firebaseAuth = getAuth(firebaseApp);
export const googleProvider = new GoogleAuthProvider();
export const appleProvider = new OAuthProvider("apple.com");

const broker = app("broker");
const $e = app("$e");

/**
 * Register for push notifications and get token
 */
export const getFirebaseToken = async (tries = 0) => {
    if (Capacitor.isNativePlatform()) {
        try {
            let permStatus = await PushNotifications.checkPermissions();

            if (permStatus.receive === "prompt") {
                permStatus = await PushNotifications.requestPermissions();
            }

            if (permStatus.receive !== "granted") {
                return;
            }

            await PushNotifications.register();
        } catch (e) {
            console.error("Error registering for push notifications", e);
        }
        return;
    }

    // Web Platform
    if (!("Notification" in window) || Notification.permission !== "granted") {
        return;
    }

    const fcm = getMessaging(firebaseApp);

    getToken(fcm, {
        vapidKey:
            "BEahsfz0kc9hEFZpl00uq_aRrvCKc1_mh7P4dPWyUJr7GmHtWWnadpjhOdnfOGkXYuzrO9odrlytjdz6jyjCPkA",
    })
        .then((token) => {
            if (!token) return;

            broker.send($e.user.has.fcmToken, payload({ token }));

            onMessage(fcm, (payload) => {
                let n = payload.notification;
                let config = {
                    body: n?.body,
                    icon: n?.icon,
                };
                new Notification(n.title, config);
            });
        })
        .catch((e) => {
            if (tries < 3) {
                return getFirebaseToken(tries + 1);
            }
            console.error("Could not retrieve Messaging token due to ", e);
        });
};

// Capacitor Listeners
if (Capacitor.isNativePlatform()) {
    PushNotifications.addListener("registration", (token) => {
        broker.send($e.user.has.fcmToken, payload({ token: token.value }));
    });

    PushNotifications.addListener("registrationError", (error) => {
        console.error("Error on registration: " + JSON.stringify(error));
    });

    PushNotifications.addListener(
        "pushNotificationReceived",
        async (notification) => {
            try {
                let permStatus = await LocalNotifications.checkPermissions();
                if (permStatus.display !== "granted") {
                    permStatus = await LocalNotifications.requestPermissions();
                }

                if (permStatus.display === "granted") {
                    await LocalNotifications.schedule({
                        notifications: [
                            {
                                title: notification.title || "",
                                body: notification.body || "",
                                id: Math.floor(Math.random() * 1000000) + 1,
                                extra: notification.data || {},
                            },
                        ],
                    });
                }
            } catch (e) {
                console.error("Error scheduling local notification", e);
            }
        },
    );

    PushNotifications.addListener(
        "pushNotificationActionPerformed",
        (notification) => {
            const data = notification.notification.data;
            if (data && data.link) {
                // Handle deep linking or navigation
                // app("router").to(data.link);
            }
        },
    );
}

broker.on([$e.system.has.notificationPermission], getFirebaseToken);
